<div class="vacancy-detail" *ngIf="vacancy">
  <!-- Purple background with nav arrows -->
  <div class="vacancy-detail__hero">
    <button class="vacancy-detail__nav-btn vacancy-detail__nav-btn--prev" *ngIf="canGoPrevious" (click)="goPrevious()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="28"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="m15 18-6-6 6-6" />
      </svg>
    </button>
    <button class="vacancy-detail__nav-btn vacancy-detail__nav-btn--next" *ngIf="canGoNext" (click)="goNext()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="28"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="m9 18 6-6-6-6" />
      </svg>
    </button>
  </div>

  <!-- Card overlay -->
  <div class="vacancy-detail__body">
    <button class="vacancy-detail__back secondary btn" (click)="goBack()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <path d="m15 18-6-6 6-6" />
      </svg>
      <span>{{ 'shared.back' | translate }}</span>
    </button>

    <div class="vacancy-detail__card">
      <div class="vacancy-detail__header">
        <div class="vacancy-detail__title-row">
          <h1 class="vacancy-detail__title">{{ vacancy.title }}</h1>
          <ng-container *ngIf="!hideMatchBar">
            <span
              *ngIf="isSurpriseMe; else matchBar"
              [class]="'match-circle match-circle--lg match-circle--' + matchColor(vacancy.matchScore)"
            ></span>
            <ng-template #matchBar>
              <div class="vacancy-match-bar" style="width: 80px; height: 24px">
                <div class="vacancy-match-bar__fill" [style.width.%]="vacancy.matchScore">
                  <span class="vacancy-match-bar__label">{{ vacancy.matchScore }}%</span>
                </div>
              </div>
            </ng-template>
          </ng-container>
        </div>
      </div>

      <div class="vacancy-detail__grid">
        <!-- Info column -->
        <div class="vacancy-detail__info-panel">
          <div class="vacancy-detail__info-item">
            <div>
              <a
                *ngIf="vacancy.organization && vacancy.orgranization_url"
                [href]="vacancy.orgranization_url"
                target="_blank"
                rel="noopener noreferrer"
                class="vacancy-detail__info-value vacancy-detail__org-link"
              >
                {{ vacancy.organization }}
              </a>
              <span *ngIf="vacancy.organization && !vacancy.orgranization_url" class="vacancy-detail__info-value">
                {{ vacancy.organization }}
              </span>
            </div>
          </div>
          <div class="vacancy-detail__info-item">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
              <circle cx="12" cy="10" r="3" />
            </svg>
            <div>
              <span class="vacancy-detail__info-label">{{ 'vacancies.detail.location' | translate }}</span>
              <span class="vacancy-detail__info-value">{{ vacancy.location }}</span>
            </div>
          </div>
          <div class="vacancy-detail__info-item">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <polyline points="12 6 12 12 16 14" />
            </svg>
            <div>
              <span class="vacancy-detail__info-label">{{ 'vacancies.detail.hours' | translate }}</span>
              <span class="vacancy-detail__info-value">{{ vacancy.hours }}</span>
            </div>
          </div>
          <div class="vacancy-detail__info-item">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
              <path d="M6 12v5c3 3 7 3 12 0v-5" />
            </svg>
            <div>
              <span class="vacancy-detail__info-label">{{ 'vacancies.detail.education_level' | translate }}</span>
              <span class="vacancy-detail__info-value">{{ vacancy.educationLevel }}</span>
            </div>
          </div>
          <div class="vacancy-detail__info-item">
            <svg
              _ngcontent-hgi-c414
              xmlns="http://www.w3.org/2000/svg "
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                _ngcontent-hgi-c414
                d="M18 7.5C16.8 6.1 15.1 5.3 13.2 5.3C9.8 5.3 7 8.3 7 12C7 15.7 9.8 18.7 13.2 18.7C15.1 18.7 16.8 17.9 18 16.5"
              ></path>
              <line _ngcontent-hgi-c414 x1="4" y1="10" x2="15" y2="10"></line>
              <line _ngcontent-hgi-c414 x1="4" y1="14" x2="15" y2="14"></line>
            </svg>
            <div>
              <span class="vacancy-detail__info-label">{{ 'vacancies.detail.salary_month' | translate }}</span>
              <span class="vacancy-detail__info-value">{{ vacancy.salary }}</span>
            </div>
          </div>
          <div class="vacancy-detail__info-item">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect width="18" height="18" x="3" y="4" rx="2" ry="2" />
              <line x1="16" x2="16" y1="2" y2="6" />
              <line x1="8" x2="8" y1="2" y2="6" />
              <line x1="3" x2="21" y1="10" y2="10" />
            </svg>
            <div>
              <span class="vacancy-detail__info-label">{{ 'vacancies.detail.posted' | translate }}</span>
              <span class="vacancy-detail__info-value">{{ vacancy.postedDate }}</span>
            </div>
          </div>
        </div>

        <!-- Skills column -->
        <div class="vacancy-detail__skills-panel">
          <div class="vacancy-detail__skills-header">
            <h3>{{ 'vacancies.detail.skills_match' | translate }}</h3>
          </div>

          <div class="vacancy-detail__skill-categories">
            <span
              class="vacancy-detail__skill-cat vacancy-detail__skill-cat--knowledge"
              (click)="hoveredSkillCategory = 'knowledge'"
              (mouseenter)="hoveredSkillCategory = 'knowledge'"
              (mouseleave)="hoveredSkillCategory = null"
            >
              {{ 'vacancies.detail.knowledge_skills' | translate }} {{ vacancy.skillCategories.knowledge.length }}
            </span>
            <span
              class="vacancy-detail__skill-cat vacancy-detail__skill-cat--soft"
              (click)="hoveredSkillCategory = 'softSkills'"
              (mouseenter)="hoveredSkillCategory = 'softSkills'"
              (mouseleave)="hoveredSkillCategory = null"
            >
              {{ 'vacancies.detail.soft_skills' | translate }} · {{ vacancy.skillCategories.softSkills.length }}
            </span>
            <span
              class="vacancy-detail__skill-cat vacancy-detail__skill-cat--lang"
              (click)="hoveredSkillCategory = 'languages'"
              (mouseenter)="hoveredSkillCategory = 'languages'"
              (mouseleave)="hoveredSkillCategory = null"
            >
              {{ 'vacancies.detail.languages' | translate }} · {{ vacancy.skillCategories.languages.length }}
            </span>
          </div>

          <div class="vacancy-detail__skill-list">
            <div *ngFor="let skill of displayedSkills" class="vacancy-detail__skill-item">
              <span class="vacancy-detail__skill-dot"></span>
              <span>{{ skill }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Description -->
    <div class="vacancy-detail__description-card" *ngIf="vacancy.description">
      <div class="vacancy-detail__description-text" [innerHTML]="displayedDescription"></div>
      <button
        *ngIf="vacancy.description && vacancy.description.length > 800"
        class="vacancy-detail__read-more"
        (click)="isExpanded = !isExpanded"
      >
        {{ 'shared.read_more' | translate }}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          [class.rotated]="isExpanded"
        >
          <path d="m6 9 6 6 6-6" />
        </svg>
      </button>
    </div>
  </div>

  <!-- Sticky footer -->
  <div class="vacancy-detail__footer">
    <div class="vacancy-detail__footer-inner">
      <button
        class="vacancy-detail__apply-btn"
        [class.vacancy-detail__apply-btn--applied]="hasApplied"
        [class.greyed-out]="!isActivated"
        [disabled]="hasApplied"
        [matTooltip]="!isActivated ? ('global.tooltip_apply_vacancy_not_activated' | translate) : ''"
        matTooltipClass="tooltip-multiline"
        (click)="apply()"
      >
        {{ (hasApplied ? 'vacancies.detail.applied' : 'vacancies.detail.apply_now') | translate }}
      </button>
      <button
        class="vacancy-btn-round vacancy-btn-heart"
        [class.vacancy-btn-heart--active]="isSaved"
        [class.greyed-out]="!isActivated"
        [matTooltip]="!isActivated ? ('global.tooltip_save_vacancy_not_activated' | translate) : ''"
        matTooltipClass="tooltip-multiline"
        (click)="toggleSave()"
        style="width: 48px; height: 48px"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          [attr.fill]="isSaved ? 'currentColor' : 'none'"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path
            d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"
          />
        </svg>
      </button>
    </div>
  </div>
</div>
